const enums = {
    variant: ['warning', 'error', 'success', 'info', 'rtns', 'default'],
    position: ['left', 'right', 'center', 'top', 'bottom'],
};
export default enums;
